/* ezspa-beeld.js — video's pas laden wanneer ze in beeld komen.

   De stappen op de productpagina waren gifs van samen 40 MB. Ze staan nu als
   mp4 in Bestanden, met een stilstaand beeld van een paar tientallen kilobytes
   als poster. Dat poster laadt meteen; de mp4 pas als je binnen 400 px komt.

   Zonder javascript, of met beweging uitgezet, blijft het stille beeld staan.
   Dat is scherper dan de gif was en kost niets.

   13 september 2026: op mobiel bleven de filmpjes stilstaan (Jaap meldde dit
   voor zowel de homepage als de productpagina). De video's staan al op
   muted+playsinline, wat play() op de meeste mobiele browsers zou moeten
   toestaan, maar een aantal configuraties (spaarstand, databesparing, of
   simpelweg een strenger beleid dan verwacht) weigert een programmatische
   play() toch, zelfs gemute. Die weigering werd stil opgevangen: het
   stilstaande beeld bleef staan en er gebeurde verder niets, precies wat
   Jaap zag. v.muted wordt nu ook als eigenschap gezet (niet alleen als
   attribuut) vlak vóór play(), en als de browser play() alsnog weigert,
   probeert dit bestand het opnieuw zodra de bezoeker de pagina voor het
   eerst aanraakt of erop klikt — na de eerste aanraking staan zulke
   beperkingen doorgaans niet meer in de weg.

   16 september 2026: naast dat stille vangnet krijgt elke video die een knop
   heeft (zie snippets/ezspa-filmknop.liquid, gebruikt in ezspa-stappen.liquid
   en ezspa-zilvergaren.liquid) nu ook zichtbare bediening. Op desktop
   verandert er niets: die speelt zoals nu al vanzelf af, en er komt een klein
   pauzeknopje rechtsonderin bij. Weigert de browser het automatisch afspelen
   (vooral op mobiel), dan verschijnt er nu een echte afspeelknop op de video
   zelf, in plaats van dat er stil wordt gewacht op een toevallige aanraking
   ergens anders op de pagina.
*/
(function () {
  /* Dit bestand wordt op de productpagina door twee secties tegelijk
     ingeladen (ezspa-stappen.liquid en ezspa-product-verhaal.liquid), dus de
     tweede keer moet er niets meer gebeuren: anders krijgt elke knop zijn
     click-handler dubbel en heft een klik zichzelf weer op. */
  if (window.ezspaBeeldGezet) return;
  window.ezspaBeeldGezet = true;

  var videos = [].slice.call(document.querySelectorAll('video[data-instroom-video]'));
  if (!videos.length) return;

  var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var wachtlijst = [];
  var luistert = false;

  function zetAanraakLuisteraar() {
    if (luistert) return;
    luistert = true;
    function opnieuwProberen() {
      wachtlijst.forEach(function (v) { v.play().catch(function () { /* blijft dan alsnog het poster */ }); });
      wachtlijst = [];
      document.removeEventListener('touchstart', opnieuwProberen);
      document.removeEventListener('pointerdown', opnieuwProberen);
    }
    document.addEventListener('touchstart', opnieuwProberen, { once: true, passive: true });
    document.addEventListener('pointerdown', opnieuwProberen, { once: true });
  }

  /* De knoppen zijn optioneel: alleen video's binnen een wikkel met
     data-ezspa-film hebben ze (zie ezspa-filmknop.liquid). Een video zonder
     die wikkel speelt gewoon stil af, zoals voorheen. */
  function knoppen(v) {
    var wrap = v.closest('[data-ezspa-film]');
    if (!wrap) return null;
    return {
      wrap: wrap,
      knop: wrap.querySelector('[data-ezspa-film-knop]'),
      start: wrap.querySelector('[data-ezspa-film-start]')
    };
  }

  function toonWacht(v) {
    var k = knoppen(v);
    if (k) k.wrap.classList.add('is-wacht');
  }
  function verbergWacht(v) {
    var k = knoppen(v);
    if (k) k.wrap.classList.remove('is-wacht');
  }
  function zetStaat(v) {
    var k = knoppen(v);
    if (!k || !k.knop) return;
    var uit = v.paused;
    k.wrap.classList.toggle('is-gepauzeerd', uit);
    k.knop.setAttribute('aria-label', uit ? k.knop.dataset.speel : k.knop.dataset.pauze);
  }

  function start(v) {
    if (v.dataset.gestart) return;
    v.dataset.gestart = '1';
    v.muted = true;
    v.preload = 'auto';
    v.load();
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        wachtlijst.push(v);
        zetAanraakLuisteraar();
        toonWacht(v);
      });
    }
  }

  videos.forEach(function (v) {
    var k = knoppen(v);
    if (!k) return;
    if (k.knop) {
      k.knop.addEventListener('click', function () {
        if (v.paused) {
          v.muted = true;
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    }
    if (k.start) {
      k.start.addEventListener('click', function () {
        v.muted = true;
        v.play().catch(function () {});
      });
    }
    v.addEventListener('play', function () { zetStaat(v); });
    v.addEventListener('pause', function () { zetStaat(v); });
    v.addEventListener('playing', function () { verbergWacht(v); });
    zetStaat(v);
  });

  if (rustig) {
    /* Met "minder beweging" aan speelt er niets vanzelf af. Heeft de video een
       knop, dan kan de bezoeker hem nog altijd zelf starten. */
    videos.forEach(toonWacht);
    return;
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(start);
    return;
  }

  var kijker = new IntersectionObserver(function (rijen) {
    rijen.forEach(function (r) {
      if (r.isIntersecting) {
        start(r.target);
        kijker.unobserve(r.target);
      }
    });
  }, { rootMargin: '400px 0px' });

  videos.forEach(function (v) { kijker.observe(v); });
})();
